import { IBreakPoint } from '../../_interfaces/IBreakPoint';
import { CardType } from './CardTypes';

export const GridTypes = {
    GetBreakPoint: (type?: CardType): Array<IBreakPoint> => {
        // todo: assert before return that these breakpoints are set that they go incrementally higher, 0 -> 300 -> 600
        switch (type) {
            case CardType.FAMILY_DETAIL:
                return [
                    { containerIsWiderThan: 0, columnCount: 1, itemHeight: 245, itemSpacing: 0 },
                    { containerIsWiderThan: 250, columnCount: 2, itemHeight: 245, itemSpacing: 5 },
                    { containerIsWiderThan: 500, columnCount: 3, itemHeight: 245, itemSpacing: 7 },
                    { containerIsWiderThan: 650, columnCount: 4, itemHeight: 245, itemSpacing: 10 },
                    { containerIsWiderThan: 800, columnCount: 5, itemHeight: 245, itemSpacing: 10 },
                    { containerIsWiderThan: 1000, columnCount: 6, itemHeight: 245, itemSpacing: 10 },
                    { containerIsWiderThan: 1200, columnCount: 7, itemHeight: 245, itemSpacing: 10 }
                ];
            default:
                return [
                    { containerIsWiderThan: 0, columnCount: 1, itemHeight: 250, itemSpacing: 0 },
                    { containerIsWiderThan: 500, columnCount: 2, itemHeight: 250, itemSpacing: 20 },
                    { containerIsWiderThan: 900, columnCount: 3, itemHeight: 250, itemSpacing: 20 },
                    { containerIsWiderThan: 1200, columnCount: 4, itemHeight: 250, itemSpacing: 20 },
                    { containerIsWiderThan: 1600, columnCount: 5, itemHeight: 250, itemSpacing: 20 }
                ];
        }
    }
};



// WEBPACK FOOTER //
// ./src/_components/GridDisplayView/GridTypes.ts